class GWPPopup extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('.gwp_popup__product_form')?.forEach((productForm) => productForm.addEventListener('submit', this.gwpAddToCart.bind(this, productForm)));

    this.querySelector('.gwp_popup__black_drop')?.addEventListener('click', this.closeGwpPopup.bind(this));
    this.querySelector('.gwp_popup__close_button')?.addEventListener('click', this.closeGwpPopup.bind(this));
  }

  openGwpPopup(callback) {
    if (window.shop.giftWithPurchase.enableLog) {
      console.log('🎁 [GWP] X.0 | POPUP OPENED');
      console.log('--- --- --- ---');
    }

    this.classList.add('visible');
    window.gwpCurrentCallback = callback;
  }
  
  closeGwpPopup() {
    if (window.shop.giftWithPurchase.enableLog) {
      console.log('🎁 [GWP] X.0 | POPUP CLOSED');
      console.log('--- --- --- ---');
    }
  
    this.classList.remove('visible');
    window.gwpCurrentCallback();
  }
  
  gwpAddToCart(form, event) {
    event.preventDefault();

    const formData = new FormData(form);
    const variantId = formData.get('gwp_popup__product_select');

    if (window.shop.giftWithPurchase.enableLog) {
      console.log('🎁 [GWP] X.0 | FORM SUBMITTED');
      console.log('         X.1 | formData ', formData);
      console.log('         X.2 | variantId ', variantId);
      console.log('--- --- --- ---');
    }

    if (!variantId) return;

    cartAjaxFetch(theme.routes.cart_add_url, variantId, 1, (response) => { window.gwpCurrentCallback(response); this.classList.remove('visible') }, { _isGWP: true });
  }
}

customElements.define('gwp-popup', GWPPopup);